import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";
const base = `${baseUrl}/auth`;

export function getDynamicViewDataList(token, query) {
  const q = buildQuery(query);
  return axios.post(
    `${baseUrl}/GetDynamicView${q}`,
    {
      page_name: "Sales Order",
      sec_name: "header",
    },
    {
      headers: {
        authorization: token,
      },
    }
  );
}
export function getPageNameData(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getPageList${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getSectionNameData(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getSectionList${q}`, {
    headers: {
      authorization: token,
    },
  });
}
// export function getPageDetailsById(token, id) {
//   return axios.get(`${baseUrl}/getPageDetailbyID/${id}`, {
//     headers: {
//       authorization: token,
//     },
//   });
// }

// export function insertPageDetail(token, data) {
//   return axios.post(`${baseUrl}/insertPageDetail`, data, {
//     headers: {
//       authorization: token,
//     },
//   });
// }

// export function updatePageDetail(token, id, data) {
//   return axios.put(`${baseUrl}/updatePageDetail/${id}`, data, {
//     headers: {
//       authorization: token,
//     },
//   });
// }
// export function getPageDetailColumnList(token, query) {
//   const q = buildQuery(query);
//   return axios.get(`${baseUrl}/getColumnsListbyView${q}`, {
//     headers: {
//       authorization: token,
//     },
//   });
// }
// export function getPageDetailTableViewList(token, query) {
//   const q = buildQuery(query);
//   return axios.get(`${baseUrl}/getViewList${q}`, {
//     headers: {
//       authorization: token,
//     },
//   });
// }
